export default __webpack_public_path__ + "static/media/forgot_password_OTP-mobile.7822a33e.webp";